<template>
  <page-template>
    <board
      :is-fold="isFold"
      :http-options="httpOptions"
      :config="config"
      :disabled-play-button="true"
      :disabled-delete-button="true"
    />
  </page-template>
</template>

<script>
import Vue from "vue";

import config from "./Config";

import DetailsEditor from "./detail-row/WineDetailEditor";
import CommonBoardItems from "../../CommonBoardItems";

Vue.component(config.detailRowComponentName, DetailsEditor);

export default {
  name: "BoardDetails",
  mixins: [CommonBoardItems],
  data() {
    return {
      config
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/wine/details/BoardDetails.vue